var render = function render(){var _vm=this,_c=_vm._self._c;return _c('switcher',{staticClass:"m-auto",attrs:{"status":+_vm.item.status ? true : false,"title":{on: _vm.SWITCHERS_VALUES.active, off: _vm.SWITCHERS_VALUES.blocked}},on:{"on-switch":() => { if (_vm.isActive) _vm.onStatusChange(_vm.item) }}})
}
var staticRenderFns = []

export { render, staticRenderFns }